import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-snp-detail',
  templateUrl: './snp-detail.component.html',
  styleUrls: ['./snp-detail.component.css']
})
export class SnpDetailComponent {

  snps: any[] = [];
  references: any[];
  selectedReference: any;
  locations: any[];
  selectedLocation: any;
  stocks: any[];
  selectedStock: any;
  uploadedFiles: any[] = [];
  sampleName: string = "";

  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private messageService: MessageService)
  {
  }

  ngOnInit() {
    var id : string = this.route.snapshot.paramMap.get("id")!;
    this.getSnps(+id);
    this.getReferences();
    this.getLocations();
    this.getStocks();
  }

  onUpload(event:any) {
    for(let file of event.files) {
        this.uploadedFiles.push(file);
    }

    this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
  }

  getSnps(id: number){
    this.dataService.getSnpsBySample(id).then(data => {
      this.snps = data;
      this.sampleName = this.snps[0].sampleName;
      if (this.references.length > 0 && this.snps[0].referenceId != null)
        this.selectedReference = this.references.filter(x => x.code == this.snps[0].referenceId)[0];
      if (this.locations.length > 0 && this.snps[0].locationId != null)
        this.selectedLocation = this.locations.filter(x => x.code == this.snps[0].locationId)[0];
      if (this.stocks.length > 0 && this.snps[0].stockId != null)
        this.selectedStock = this.stocks.filter(x => x.code == this.snps[0].stockId)[0];
    });
  }

  getLocations()
  {
    this.dataService.getLocations().then(data => {
      this.locations = data.map((s: { name: any; locationId: any; }) => ({name: s.name, code: s.locationId}))
      if(this.snps.length > 0)
        this.selectedLocation = this.locations.filter(x => x.code == this.snps[0].locationId)[0];
    });
  }

  getStocks()
  {
    this.dataService.getStocks().then(data => {
      this.stocks = data.map((s: { name: any; stockId: any; }) => ({name: s.name, code: s.stockId}))
      console.log(data);
      console.log(this.stocks);
      if(this.snps.length > 0)
        this.selectedStock = this.stocks.filter(x => x.code == this.snps[0].stockId)[0];
    });
  }

  getReferences()
  {
    this.dataService.getReferences().then(data => {
      this.references = data.map((s: { name: any; referenceId: any; }) => ({name: s.name, code: s.referenceId}));
      if(this.snps.length > 0)
        this.selectedReference = this.references.filter(x => x.code == this.snps[0].referenceId)[0];
    });
  }

  getSnpClass(result: string, reference: string){
    if (result.trim() == reference)
    {
      return "snp-match";
    }
    else
    {
      return "snp-nomatch";
    }
  }

  referenceChange(){
    this.snps[0].referenceId = this.selectedReference.code;

    this.dataService.updateSnpRecord(this.snps[0]).then(data =>
      {
        this.messageService.add({severity:'success', summary:'Reference updated successfully.'});
        this.getSnps(this.snps[0].sampleId);
      });
  }

  locationChange(){
    this.snps[0].locationId = this.selectedLocation.code;
    this.dataService.updateSnpRecord(this.snps[0]).then(data =>
      {
        this.messageService.add({severity:'success', summary:'Location updated successfully.'});
        this.getSnps(this.snps[0].sampleId);
      });
  }

  stockChange(){
    this.snps[0].stockId = this.selectedStock.code;
    this.dataService.updateSnpRecord(this.snps[0]).then(data =>
      {
        this.messageService.add({severity:'success', summary:'Stock updated successfully.'});
        this.getSnps(this.snps[0].sampleId);
      });
  }

  SampleNameChange()
  {
    this.snps[0].sampleName = this.sampleName;
    this.dataService.updateSnpRecord(this.snps[0]).then(data => {
      this.messageService.add({severity:'success', summary:'Sample Name updated successfully.'});
      this.getSnps(this.snps[0].sampleId);
    });
  }
  //updateSnpReference
}
